import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp, faGear } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { activateMenu, selectSelectedMenu, selectedMenuChange } from '../ui/sidebarMenuReducer.js';
import UiAction from "./UiAction";
import uiManager from '../../config/ui.js';
import { resetQueryParams } from "../ui/customerListingReducer.js";

const Navlink = ({ menuItem, editMode, editModePermissions, setEditModePermissions, editModeSetSelectedUiAction, parentIsOpen, editModeSelectedUiActionBreadcrumb, editModeSetSelectedUiActionBreadcrumb, indentationLevel = 0, searchQuery }) => {
  const selectedMenuUiActionName = useSelector(selectSelectedMenu);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setIsOpen(getOpenState());
  }, [selectedMenuUiActionName]);

  const isSelected = (mItem) => {
    return selectedMenuUiActionName === mItem.uiAction.actionName;
  };

  const isChildSelected = (mItem) => {
    return mItem.children.reduce((val, chItem) => {
      let newVal = val || isSelected(chItem) || isChildSelected(chItem);
      return newVal;
    }, false);
  };

  const getOpenState = () => {
    return isSelected(menuItem) || isChildSelected(menuItem);
  };

  const handleToggle = (e) => {
    setIsOpen(!isOpen);
  };

  const handleCheckWrapperSpanOnClick = (e) => {
    if (editMode) {
      let editModePermissionsCopy = [...editModePermissions];
      if (e.target.tagName === 'SPAN') {
        e.preventDefault();
      } else {
        e.stopPropagation();
      }
      if (e.target.checked) {
        editModePermissionsCopy = [...editModePermissionsCopy, menuItem.uiAction.actionName];
      } else {
        editModePermissionsCopy = editModePermissionsCopy.filter((item) => item !== menuItem.uiAction.actionName);
      }
      editModePermissionsCopy = handleParentPermissions(editModePermissionsCopy, menuItem);
      setEditModePermissions(editModePermissionsCopy);
    }
  };

  const handleParentPermissions = (editModePermissionsCopy, menuItem) => {
    const parentMenuItem = menuItem.parentMenuItem;
    if (parentMenuItem) {
      let anyChildMenuItemSelected = parentMenuItem.children.filter((childMenuItem) => editModePermissionsCopy.indexOf(childMenuItem.uiAction.actionName) !== -1).length !== 0;
      if (!anyChildMenuItemSelected) {
        editModePermissionsCopy = editModePermissionsCopy.filter((item) => item !== parentMenuItem.uiAction.actionName);
        editModePermissionsCopy = handleParentPermissions(editModePermissionsCopy, parentMenuItem);
      } else {
        if (editModePermissionsCopy.indexOf(parentMenuItem.uiAction.actionName) === -1) {
          editModePermissionsCopy = [...editModePermissionsCopy, parentMenuItem.uiAction.actionName];
          editModePermissionsCopy = handleParentPermissions(editModePermissionsCopy, parentMenuItem);
        }
      }
    }
    return editModePermissionsCopy;
  };

  const isChecked = () => {
    return editModePermissions.indexOf(menuItem.uiAction.actionName) !== -1;
  };

  const onMenuSelected = (e) => {
    if (!editMode) {
      if (!menuItem.hasChildren()) {
        if (selectedMenuUiActionName !== menuItem.uiAction.actionName){
          dispatch(activateMenu(selectedMenuChange(menuItem.uiAction.actionName)));
          dispatch(resetQueryParams());
        }
      }
    }
  };

  const onEditModeConfigureClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    editModeSetSelectedUiActionBreadcrumb([[menuItem.uiAction.actionName, uiManager.getUiAction(menuItem.uiAction.actionName).linkedUiPage.getTitle()]]);
    editModeSetSelectedUiAction(menuItem.uiAction.actionName);
  };

  const filterMenuItem = (item) => {
    return item.label.toLowerCase().includes(searchQuery.toLowerCase()) || (item.children && item.children.some(child => filterMenuItem(child)));
  };

  return (
    <>
      {filterMenuItem(menuItem) && (
        <Link to={editMode ? null : menuItem.uiRoute?.path} onClick={handleToggle}>
          <li
            style={
              (isOpen || parentIsOpen) && menuItem.hasChildren()
                ? {
                  backgroundColor: "#AFE1AF",
                  fontWeight: 600,
                  paddingLeft: `${12 * (indentationLevel + 1)}px`,
                }
                : parentIsOpen
                  ? {
                    backgroundColor: "#E4F0E1",
                    paddingLeft: `${12 * (indentationLevel + 1)}px`,
                  }
                  : {}
            }
            className={`${!editMode && isSelected(menuItem) ? 'active' : ''}`}
            onClick={onMenuSelected}
          >
            <span onClick={handleCheckWrapperSpanOnClick}>
              {editMode && <input
                className="permission-checkbox"
                type="checkbox"
                value={menuItem.uiAction.actionName}
                checked={isChecked()}
                onChange={handleCheckWrapperSpanOnClick}
              />}
              <span>{menuItem.label}</span>
            </span>
            {menuItem.hasChildren() && (
              <FontAwesomeIcon icon={isOpen ? faAngleUp : faAngleDown} />
            )}
            {editMode && !menuItem.hasChildren() && editModePermissions.indexOf(menuItem.uiAction.actionName) !== -1 && (
              <span className="float-end btn btn-secondary btn-xs" onClick={onEditModeConfigureClick}>
                <FontAwesomeIcon icon={faGear} />
              </span>
            )}
          </li>
        </Link>
      )}

      {isOpen &&
        menuItem.hasChildren() &&
        menuItem.children.map((childMenuItem) => (
          <UiAction key={childMenuItem.uiAction.actionName} uiAction={childMenuItem.uiAction} editMode={editMode}>
            <Navlink
              menuItem={childMenuItem}
              parentIsOpen={isOpen}
              indentationLevel={indentationLevel + 1}
              editMode={editMode}
              editModePermissions={editModePermissions}
              setEditModePermissions={setEditModePermissions}
              editModeSetSelectedUiAction={editModeSetSelectedUiAction}
              editModeSelectedUiActionBreadcrumb={editModeSelectedUiActionBreadcrumb}
              editModeSetSelectedUiActionBreadcrumb={editModeSetSelectedUiActionBreadcrumb}
              searchQuery={searchQuery}
            />
          </UiAction>
        ))}
    </>
  );
};

export default Navlink;
